<template>
  <div class="widget-visibility-config">
    <b-link v-if="!locked"
            class="widget-config-link mr-3"
            :disabled="disabled"
            @click="open"
            v-b-tooltip.hover.bottom
            title="Configurar visibilidad de widgets">
      <AppIcon icon="grid1x2"></AppIcon>
    </b-link>

    <b-link class="widget-lock-link mr-3"
            :class="{ 'is-locked': locked }"
            :disabled="disabled"
            @click="toggleLock"
            v-b-tooltip.hover.bottom
            :title="locked ? 'Dashboard bloqueado. Click para desbloquear' : 'Click para bloquear el dashboard'">
      <AppIcon :icon="locked ? 'lock-fill' : 'unlock'"></AppIcon>
    </b-link>

    <b-modal v-model="active"
             header-bg-variant="primary"
             header-text-variant="white">
      <div slot="modal-header">
        {{ title }}
      </div>

      <b-list-group v-if="widgets.length">
        <b-list-group-item v-for="item in widgets" :key="item.reference" class="widget-visibility-item flex-column align-items-start">
          <div class="d-flex w-100 justify-content-between align-items-center">
            <div>
              <h6 class="mb-1">{{ item.title }}</h6>
              <small class="text-muted" v-if="item.description">{{ item.description }}</small>
              <b-badge v-if="!item.hasAccess" variant="warning" class="ml-2">Sin permisos</b-badge>
              <b-badge v-if="locked" variant="secondary" class="ml-2">Bloqueado</b-badge>
            </div>
            <b-form-checkbox
              switch
              size="sm"
              :disabled="locked || !item.hasAccess"
              :checked="isVisible(item.reference)"
              @change="toggle(item.reference, $event)">
              {{ isVisible(item.reference) ? 'Visible' : 'Oculto' }}
            </b-form-checkbox>
          </div>
        </b-list-group-item>
      </b-list-group>
      <b-badge v-else variant="warning" class="p-3 badge-dashboard-widget-config">No hay widget para configurar</b-badge>

      <template v-slot:modal-footer>
        <b-button variant="outline-secondary" class="mr-1" @click="active=false">Cerrar</b-button>
        <b-button variant="primary" :disabled="locked" @click="reset">Restaurar todo</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  export default {
    props: {
      widgets: {
        type: Array,
        default: () => []
      },
      hidden: {
        type: Array,
        default: () => []
      },
      title: {
        type: String,
        default: 'Configurar Widgets'
      },
      buttonText: {
        type: String,
        default: 'Widgets'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      locked: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        active: false
      }
    },
    methods: {
      open() {
        if(!this.disabled) {
          this.active = true
        }
      },
      isVisible(reference) {
        return this.hidden.indexOf(reference) === -1
      },
      toggle(reference, visible) {
        if(this.locked) {
          return
        }
        this.$emit('toggle', { reference, visible })
      },
      reset() {
        if(this.locked) {
          return
        }
        this.$emit('reset')
      },
      toggleLock() {
        this.$emit('toggle-lock', !this.locked)
      }
    }
  }
</script>

<style>
  .badge-dashboard-widget-config {
    font-size: 15px;
    text-align: center;
    width: 100%;
  }
  .widget-config-link {
    font-size: 16px;
    color: var(--app-color-icon);
    cursor: pointer;
  }
  .widget-config-link:hover {
    color: var(--app-color-primary);
  }
  .widget-lock-link {
    font-size: 16px;
    color: var(--app-color-danger);
    cursor: pointer;
    animation: blink-lock 1.5s ease-in-out infinite;
  }
  .widget-lock-link:hover {
    color: var(--app-color-danger-hover);
  }
  .widget-lock-link.is-locked {
    color: var(--app-color-text-secondary);
    animation: none;
  }
  .widget-lock-link.is-locked:hover {
    color: var(--app-color-text-muted);
  }
  .widget-visibility-item {
    border-color: var(--app-color-border);
    background: var(--app-color-surface);
  }
  .widget-visibility-item + .widget-visibility-item {
    margin-top: 6px;
    border-top-width: 1px;
  }
  .widget-visibility-item h6 {
    color: var(--app-color-text);
    font-size: var(--app-text-sm);
    font-weight: var(--app-font-semibold);
  }
  .widget-visibility-item small {
    color: var(--app-color-text-muted) !important;
  }
  @keyframes blink-lock {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.3; }
  }
</style>
